// --- SideControls.jsx ---
export default function SideControls({ showSliders, picker, sliders, isDarkMode }) {
  const tone = isDarkMode ? "dark" : "light";
  return (
    <aside
      className="
        shrink-0
        w-full xl:w-auto
      "
      style={{ width: showSliders ? "clamp(360px, 26vw, 480px)" : "clamp(260px, 22vw, 320px)" }}
    >
      <div
        className="
          grid gap-3 items-stretch
          grid-cols-1
          xl:grid-cols-2
        "
      >
        <div className={`control-card ${tone} h-full min-w-0`}>{picker}</div>
        {showSliders && (
          <div className={`control-card ${tone} h-full min-w-0`}>{sliders}</div>
        )}
      </div>
    </aside>
  );
}